import React, { useRef, useState } from "react";
import { Button, Modal, ModalBody, Col } from "reactstrap";
import InputTextComponent from "../../../../components/forms/InputTextComponent";
const translator = require("../../../../utils/translator/translator");

const AddNotesForm = ({
     cookingInstruction: _cookingInstruction = "",
     internalNotes: _internalNotes = "",
     showInternalNotes = false,
     onSubmit = (values) => {},
     onCancel = () => {},
}) => {
     const [cookingInstruction, setCookingInstruction] = useState(_cookingInstruction);
     const [internalNotes, setInternalNotes] = useState(_internalNotes);

     const inputFieldRef = useRef(null);

     const handleOnCancel = () => onCancel();

     const handleOnSubmit = () => {
          if (showInternalNotes) {
               onSubmit({ cookingInstruction, internalNotes });
          } else {
               onSubmit({ cookingInstruction });
          }
     };

     const handleModalOpen = () => {
          inputFieldRef.current.focus();
     };

     return (
          <Modal isOpen size="lg" animation={false} fade={false} onOpened={handleModalOpen}>
               <div className="p-3 d-flex align-items-center border-bottom">
                    <div className="window-title">{translator.getLabel("cooking_instructions")}</div>
                    <div className="d-flex flex-fill justify-content-end gap-2">
                         <Button className="btn-cancel" onClick={handleOnCancel}>
                              {translator.getLabel("cancel")}
                         </Button>
                         <Button className="btn-ok" onClick={handleOnSubmit}>
                              {translator.getLabel("done")}
                         </Button>
                    </div>
               </div>
               <ModalBody>
                    <div className="d-flex flex-row gap-3">
                         <Col>
                              <InputTextComponent
                                   type="textarea"
                                   inputTextType="text"
                                   placeholder={translator.getLabel("cooking_instructions")}
                                   value={cookingInstruction}
                                   onValueChange={(value, name) => setCookingInstruction(value)}
                                   style={{ minHeight: "8rem" }}
                                   internalRef={inputFieldRef}
                              />
                         </Col>
                         {showInternalNotes && (
                              <Col>
                                   <InputTextComponent
                                        type="textarea"
                                        inputTextType="text"
                                        placeholder={translator.getLabel("internal_notes")}
                                        value={internalNotes}
                                        onValueChange={(value, name) => setInternalNotes(value)}
                                        style={{ minHeight: "8rem" }}
                                   />
                              </Col>
                         )}
                    </div>
               </ModalBody>
          </Modal>
     );
};

export default AddNotesForm;
